import React from 'react'
import { Form, Input } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from '../CustomPasswordInput/CustomPasswordInput.module.scss'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'

interface CustomConfirmPasswordInputProps {
  name: string,
  placeholder: string
}

const CustomConfirmPasswordInput: React.FC<CustomConfirmPasswordInputProps> = (props) => {
  const { name, placeholder } = props
  const { t } = useTranslation()

  return (
    <>
      <Form.Item
        name={name}
        dependencies={['password']}
        rules={[
          { required: true, message: t('general.RequiredValidation'), whitespace: true },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve()
              }
              return Promise.reject(new Error(t('general.PasswordConfirmError')))
            },
          })
        ]}
      >
        <Input.Password
          placeholder={placeholder}
          size='large'
          className={styles['custom-password-input']}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
      </Form.Item>
    </>
  )
}

export default CustomConfirmPasswordInput
